import Vue from "vue";

// Create a global event bus for components to communicate
export const EventBus = new Vue();

// Event names as constants to avoid typos
export const Events = {
  // Generic app-wide dialog request (listened for by CreditWarningDialog).
  SHOW_DIALOG: "show-dialog"
};
